import { useState } from 'react';
import { Box } from '@mui/material';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';

import {
  CtaButton,
  ModalContainer,
  TextInput,
} from '@tassomutuo-backoffice/ui';
import { TeamGroup } from '@tassomutuo-backoffice/types';

interface IFormInputs {
  name: string;
}

interface IProps {
  handleClose: () => void;
  createTeamGroup: (
    teamGroupData: Omit<TeamGroup, 'id' | 'team'>
  ) => Promise<void>;
  disabled: boolean;
}

const TeamsDetailGroupFormModal = ({
  handleClose,
  createTeamGroup,
  disabled,
}: IProps) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<IFormInputs>();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
    try {
      setIsLoading(true);

      await createTeamGroup({ name: data.name });

      handleClose();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open
      handleClose={handleClose}
      title="Nuovo gruppo"
      containerSx={{ maxWidth: '500px' }}
      mtHeader={0}
    >
      <Box
        width="100%"
        component="form"
        maxHeight="60vh"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Controller
          control={control}
          name="name"
          rules={{
            required: 'Campo obbligatorio',
          }}
          defaultValue=""
          render={({ field }) => (
            <TextInput
              type="text"
              label="Nome gruppo"
              helperText={errors?.name?.message}
              error={!!errors?.name}
              {...field}
            />
          )}
        />

        <Box display="flex" justifyContent="center" my={4}>
          <CtaButton
            variant="contained"
            type="submit"
            loading={isLoading}
            disabled={disabled}
          >
            SALVA
          </CtaButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default TeamsDetailGroupFormModal;
